import { useEffect, useState } from "react";
import { useField, Formik } from "formik";
import ImageUploading from "react-images-uploading";
import Close from "./Close";
import UploadButton from "./UploadButton";
import Resizer from "react-image-file-resizer";

export default function Upload({ name }) {
  const [field, meta, helpers] = useField(name);
  const [fieldValue, setFieldValue] = useState("");
  const [fileName, setFileName] = useState();
  const handleFileRead = async (event) => {
    const file = event.target.files[0];
    setFieldValue(event.target.value);
    setFileName(file.name);
    if (file.type === "application/pdf") {
      var fileReader = new FileReader();
      fileReader.onload = function (fileLoadedEvent) {
        helpers.setValue(fileLoadedEvent.target.result);
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    } else {
      const base64 = await resizeFile(file);
      helpers.setValue(base64);
    }
  };

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1600,
        1600,
        "JPEG",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64"
      );
    });
  const removeFile = () => {
    helpers.setValue(null);
    setFieldValue("");
    setFileName("");
  };
  return (
    <div>
      <div className="upload__image-wrapper">
        {fieldValue && <Close clickHandler={removeFile} />}
        <label htmlFor={name}>
          <UploadButton value={field.value} fileName={fileName} />
          <input
            id={name}
            value={fieldValue}
            accept=".pdf, .jpg ,.jpeg, .png"
            type="file"
            onChange={handleFileRead}
          />
        </label>
      </div>
    </div>
  );
}
